export default __webpack_public_path__ + "static/media/pdf_icon.ed8e7063.png";